module.exports = __webpack_public_path__ + "static/media/app-store-badge.d0558d91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Landing/app-store-badge.svg
// module id = 73
// module chunks = 0